import api from './config';

/**
 * 获取设备列表
 * @param {Object} params 查询参数
 */
export function getDevices(params = {}) {
  return api.get('/devices', { params });
}

/**
 * 获取设备详情
 * @param {string} id 设备ID
 */
export function getDeviceById(id) {
  return api.get(`/devices/${id}`);
}

/**
 * 注册/添加设备
 * @param {Object} data 设备数据
 */
export function registerDevice(data) {
  return api.post('/devices', data);
}

/**
 * 编辑设备
 * @param {string} id 设备ID
 * @param {Object} data 设备数据
 */
export function updateDevice(id, data) {
  return api.put(`/devices/${id}`, data);
}

/**
 * 删除设备
 * @param {string} id 设备ID
 */
export function deleteDevice(id) {
  return api.delete(`/devices/${id}`);
} 

/**
 * 批量导入设备（CSV 文件）
 * @param {FormData} formData 包含 file 字段的表单数据
 */
export function importDevices(formData) {
  return api.post('/devices_import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 获取设备小程序码
 * @param {string} deviceId 设备ID（可以是数据库ID或MAC地址）
 * @param {Object} params 可选参数：page, check_path, env_version, force
 * @returns {Promise} 返回Promise，resolve的值可能是：
 *   - {success: true, url: string, cached: boolean} - 如果已有二维码URL（JSON响应）
 *   - {data: Blob} - 如果是图片二进制数据（七牛云未配置时）
 */
export function getDeviceQrcode(deviceId, params = {}) {
  // 使用原生axios请求，因为需要处理JSON和blob两种响应类型
  const axios = require('axios').default;
  const token = localStorage.getItem('token');
  const baseURL = process.env.VUE_APP_API_BASE_URL || '';
  const fullURL = baseURL ? 
    (baseURL.endsWith('/api') ? baseURL : `${baseURL}/api`) : 
    '/api';
  
  return axios.get(`${fullURL}/devices/${deviceId}/qrcode`, {
    params,
    responseType: 'arraybuffer', // 使用arraybuffer以便检查Content-Type
    headers: {
      'Authorization': token ? `Bearer ${token}` : ''
    }
  }).then(response => {
    const contentType = response.headers['content-type'] || '';
    
    // 如果是JSON响应
    if (contentType.includes('application/json')) {
      const text = new TextDecoder('utf-8').decode(response.data);
      const json = JSON.parse(text);
      return json;
    }
    
    // 如果是图片响应，转换为Blob
    const blob = new Blob([response.data], { type: contentType || 'image/png' });
    return { data: blob };
  });
}

/**
 * 获取硬件版型列表
 * @param {Object} params 查询参数，如 { all: true } 显示所有包括禁用的
 */
export function getBoardTypes(params = {}) {
  return api.get('/board-types', { params });
}

/**
 * 创建新版型
 * @param {Object} data { name, description }
 */
export function createBoardType(data) {
  return api.post('/board-types', data);
}

/**
 * 更新版型信息
 * @param {string} id 版型ID
 * @param {Object} data { name, description, is_enabled }
 */
export function updateBoardType(id, data) {
  return api.put(`/board-types/${id}`, data);
}

/**
 * 删除版型
 * @param {string} id 版型ID
 */
export function deleteBoardType(id) {
  return api.delete(`/board-types/${id}`);
}
